import { getMySurveys } from '../../services/data-entry/surveys.service';

//Surveys list
export const UPDATE_MY_SURVEYS_LIST = 'UPDATE_MY_SURVEYS_LIST';
export const TOGGLE_MY_SURVEYS_LIST_LOADING = 'TOGGLE_MY_SURVEYS_LIST_LOADING';
export const MY_SURVEYS_LIST_ERROR = 'MY_SURVEYS_LIST_ERROR';
export const MY_SURVEYS_UPDATE_TOTAL_LIST = 'MY_SURVEYS_UPDATE_TOTAL_LIST';

// About me
export const MY_SURVEYS_ABOUT_ME_UPDATE_LIST = 'MY_SURVEYS_ABOUT_ME_UPDATE_LIST';
export const MY_SURVEYS_ABOUT_ME_TOGGLE_LOADING = 'MY_SURVEYS_ABOUT_ME_TOGGLE_LOADING';
export const MY_SURVEYS_ABOUT_ME_UPDATE_ERROR = 'MY_SURVEYS_ABOUT_ME_UPDATE_ERROR';

// About my classes
export const MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_LIST = 'MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_LIST';
export const MY_SURVEYS_ABOUT_MY_CLASSES_TOGGLE_LOADING = 'MY_SURVEYS_ABOUT_MY_CLASSES_TOGGLE_LOADING';
export const MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_ERROR = 'MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_ERROR';

export const updateMySurveysList = (value = []) => ({
  type: UPDATE_MY_SURVEYS_LIST,
  payload: { name: 'list', value }
});

export const mySurveysListError = (value = null) => ({
  type: MY_SURVEYS_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingMySurveys = (value = false) => ({
  type: TOGGLE_MY_SURVEYS_LIST_LOADING,
  payload: { name: 'loading', value }
});

export const updateMySurveysTotalList = (value = 0) => ({
  type: MY_SURVEYS_UPDATE_TOTAL_LIST,
  payload: { value }
});

export const updateAboutMeSurveysList = ({data = [], count = 0}) => ({
  type: MY_SURVEYS_ABOUT_ME_UPDATE_LIST,
  payload: { data, count }
});
export const toggleLoadingAboutMeSurveys = (loading = false) => ({
  type: MY_SURVEYS_ABOUT_ME_TOGGLE_LOADING,
  payload: { loading }
});
export const updateAboutMeSurveysError = (error = null) => ({
  type: MY_SURVEYS_ABOUT_ME_UPDATE_ERROR,
  payload: { error }
});

export const updateAboutMyClassesSurveysList = ({data = [], count = 0}) => ({
  type: MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_LIST,
  payload: { data, count }
});
export const toggleLoadingAboutMyClassesSurveys = (loading = false) => ({
  type: MY_SURVEYS_ABOUT_MY_CLASSES_TOGGLE_LOADING,
  payload: { loading }
});
export const updateAboutMyClassesSurveysError = (error = null) => ({
  type: MY_SURVEYS_ABOUT_MY_CLASSES_UPDATE_ERROR,
  payload: { error }
});

export const loadMySurveys = (skip = 0, limit = 50, filter, active = true) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingMySurveys(true));
      dispatch(mySurveysListError());

      const { data } = await getMySurveys(skip, limit, filter, active);

      if (data) {
        dispatch(updateMySurveysList(data?.paginatedResults ?? []));
        dispatch(updateMySurveysTotalList(data?.totalRecords ?? 0));
        return;
      } else {
        dispatch(updateMySurveysList([]));
        dispatch(updateMySurveysTotalList(0));
      }
    } catch (error) {
      dispatch(updateMySurveysList([]));
      dispatch(updateMySurveysTotalList(0));
    } finally {
      dispatch(toggleLoadingMySurveys());
      dispatch(mySurveysListError());
    }
  };
};
